export { default as Divider } from './component';
export type { DividerProps } from './types';
